/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  /**
   * Модель для фильтра с одним вариантом выбора.
   */
  app.Filters.SelectFilter = app.Model.extend({
    defaults: {
      object: false,
      element: false
    },
    viewClass: app.Filters.SelectFilterView,
    
    run: function () {
      if (this.get('isRoot') && !app.isMobile) {
        this.viewClass = app.Filters.RootSelectFilterView;
      }
      var object = this.get('object'),
        value,
        name;
      for (var prop in object.values) {
        if (object.values[prop].selected) {
          value = object.values[prop].id;
          name = object.values[prop].name;
          break;
        }
      }
      object.values = _.sortBy(object.values, function (value) {
        return parseFloat(value.name) ? parseFloat(value.name) : value.name;
      });
      
      this.set('value', value);
      this.set('name', name);
      this.view = new this.viewClass({
        model: this,
        object: object,
        parent: this.get('element')
      });
    },
    /**
     * Дополняет объект с параметрами фильтрации
     * @param obj Исходный объект
     * @returns {Object}
     */
    toQuery: function (obj) {
      if (this.get('value') || this.get('value') === 0) {
        if (this.get('object').type === 'JsonSelect') {
          obj[this.get('object').name] = [String(this.get('value'))];
        } else {
          obj[this.get('object').name] = this.get('value');
        }
      }
      return obj;
    }
  });
})();

}.call(window));